import { FieldPropName, QueryBuilderKeyword } from './types';

export const GA_FIELDS_BASE_URL = (resource: string) => `sources/google_ads/${resource}/fields`;
export const GA_FIELDS_FETCH_ERROR =
  'An error ocurred while trying to fetch fields. Please try again later';

export const GA_FIELD_CATEGORY = {
  SEGMENT: 'SEGMENT',
  ATTRIBUTE: 'ATTRIBUTE',
  METRIC: 'METRIC',
};

export const GA_FIELD_PROPERTY = {
  SEGMENTS: 'segments' as FieldPropName,
  ATTRIBUTES: 'attributes' as FieldPropName,
  METRICS: 'metrics' as FieldPropName,
};

export const QUERY_KEYWORD = {
  SELECT: 'SELECT' as QueryBuilderKeyword,
  WHERE: 'WHERE' as QueryBuilderKeyword,
  LIMIT: 'LIMIT' as QueryBuilderKeyword,
  ORDER_BY: 'ORDER_BY' as QueryBuilderKeyword,
  PARAMETERS: 'PARAMETERS' as QueryBuilderKeyword,
};

export const EDITOR_COMMANDS = {
  BACKSPACE: 'backspace',
  DEL: 'del',
  INSERT: 'insertstring',
};
